<template>
	<div>
		<div class="content">
			<div class="container help-center">
				<leftAbout></leftAbout>
				<div class="help-main">
					<h2>常见问题</h2>
					<div class="help-cont">
						<div class="faq-group">
							<el-collapse v-model="activeName" accordion style="border-top: none;">
							  <el-collapse-item :title="item.article_title" :name="index+1" v-for="(item,index) in problemList" :key="index">
									<p  v-html="item.article_content"></p>
							  </el-collapse-item>
							</el-collapse>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import leftAbout from '../common/about/index.vue'
	export default{
		data(){
			return{
				// problemList:[],
				activeName:"",
				problemList:[

				],
			}
		},
		components:{
			leftAbout
		},
		created(){
			this.problem()
		},
		methods:{
			problem() {
				// localStorage.setItem("token","4564654")
				let token = localStorage.getItem('token')
					this.$api.issue({
							token:token
					}).then(res => {
							if(res.code === 1){
								for(let i=0;i<res.data.length;i++){
									res.data[i].article_content = this.HTMLDecode(res.data[i].article_content)
									this.problemList.push(res.data[i])
								}
							}
					})
			},
			HTMLDecode(text) {
				var temp = document.createElement("div");
				temp.innerHTML = text;
				var output = temp.innerText || temp.textContent;
				temp = null;
				return output;
			},
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/about/problem.vue